import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const target = document.getElementById('amsive-comments--root');

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0
}

const onObserver = (entries, observer) => {
  entries.forEach((entry) => {
    if(entry.intersectionRatio > 0){
      const root = ReactDOM.createRoot(target);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );

      observer.unobserve(entry.target);
    }
  });
};

const observer = new IntersectionObserver(onObserver, options);
observer.observe(target);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
